var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransferred(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FEB850"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.714 10.2855L19.714 9.28553L20.714 9.28553L20.714 10.2855L19.714 10.2855ZM11.5823 19.8315C11.1917 20.222 10.5586 20.222 10.1681 19.8315C9.77753 19.441 9.77753 18.8078 10.1681 18.4173L11.5823 19.8315ZM12.6429 9.28553H19.714L19.714 11.2855H12.6429L12.6429 9.28553ZM20.714 10.2855L20.714 17.3566H18.714L18.714 10.2855L20.714 10.2855ZM20.4211 10.9926L11.5823 19.8315L10.1681 18.4173L19.0069 9.57843L20.4211 10.9926Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferred);
export default __webpack_public_path__ + "static/media/transferred.1603d824a429259dd6a70ec5e59bdb48.svg";
export { ForwardRef as ReactComponent };